import { MissionList } from './components/list';
import { MissionHero } from './components/hero';
import { MissionSearch } from './components/search';
import { useRoot } from './hooks/useRoot';
import { useMissionListingStore } from './store/useMissionListingStore';
import { Suspense, useCallback, startTransition } from 'react';
import { ErrorScreen } from '../../Error';
import { LoadingContainer } from '../shared/components/loading-container';
import { TabsListing, TabsListingEnum } from '../shared/components/tabs-listing';
import { ProgrammesList } from './components/programmes';
import { ConsoleCJ } from '../../Error/Console';
import Container from '@/components/Container';
import { useNavigate } from 'react-router-dom';
import { MissionListLoading } from './components/loading';
import { useList } from './hooks/useList';

export const MissionListing = () => {
  const { errors, currentTab, setCurrentTab } = useRoot();
  const navigate = useNavigate();
  const missionListPage = useMissionListingStore((state) => state.missionListPage);
  const { totalCountWithoutFilters } = useList();

  const header = useCallback(() => {
    if (!missionListPage?.searchSection) {
      return <></>;
    }

    return (
      <div className="my-sh-30">
        <MissionHero />
        {!!totalCountWithoutFilters && totalCountWithoutFilters > 1 && <MissionSearch />}
        {/* <p className="my-sh-30 font-cadiz text-sh-28-32 font-bold">{missionListPage?.resultsSection?.title}</p> */}
      </div>
    );
  }, [missionListPage, totalCountWithoutFilters]);

  if (errors.length > 0) {
    ConsoleCJ.customError('MissionListingScreen', {
      ...errors,
    });
    return <ErrorScreen />;
  }

  return (
    <Container className="!mt-sh-60">
      <div className=" col-span-12 lg:col-start-11 lg:col-end-3 ">
        <TabsListing
          tabsListPage={missionListPage?.tabs}
          currentTab={currentTab}
          setCurrentTab={(tab) => {
            setCurrentTab(tab);
            startTransition(() => {
              navigate(`/${tab}`);
            });
          }}
        />

        <div>
          <div className={currentTab === TabsListingEnum.MISSIONS ? 'flex' : 'hidden'}>
            <Suspense fallback={<MissionListLoading />}>
              <MissionList headerComponent={header} />
            </Suspense>
          </div>
          <div className={currentTab === TabsListingEnum.PROGRAMMES ? 'flex' : 'hidden'}>
            <ProgrammesList />
          </div>
        </div>
      </div>
    </Container>
  );
};

export const MissionListingScreen = () => {
  return (
    <Suspense fallback={<LoadingContainer title="Loading missions..." />}>
      <MissionListing />
    </Suspense>
  );
};
